import { Routes, Route, Navigate } from 'react-router-dom';
import PlatformManagement from '../../../SettingsScreen/components/PlatformManagement/PlatformManagement';
import OrganizationDetailPage from './OrganizationDetailPage';
import UserAnalyticsPage from './UserAnalyticsPage';

const OrganizationsRouter = () => (
  <Routes>
    <Route index element={<PlatformManagement />} />
    <Route path=":orgId" element={<OrganizationDetailPage />} />
    <Route path=":orgId/users/:userId" element={<UserAnalyticsPage />} />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

export default OrganizationsRouter;
